import type { HITLConfig } from '../../tool-config-types';

/**
 * HITL config for create-memory-tool
 * Extracts memory content and category for editing
 */
export const memoryHitlConfig: HITLConfig = {
  extractData: (args: Record<string, unknown>): unknown[] => {
    // Memory tool expects content and optional category
    if (args.content) {
      return [
        {
          content: args.content,
          category: args.category,
        },
      ];
    }
    return [];
  },
  wrapEditedData: (data: unknown[]): Record<string, unknown> => {
    // Unwrap single memory back to flat args
    if (data.length === 1) {
      const memory = data[0] as Record<string, unknown>;
      const result: Record<string, unknown> = {
        content: memory.content,
      };
      if (memory.category) {
        result.category = memory.category;
      }
      return result;
    }
    return {};
  },
};
